import { render } from "./ReportToEmployeeAutocomplete.vue?vue&type=template&id=69878dfc"
import script from "./ReportToEmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportToEmployeeAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__